import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useMemo } from 'react';
import { BuilderSkill } from '@/modules/__generated__/graphql/switchboard-generated';
import { BuildersSkillsChip } from '@/modules/shared/components/chips/builders-skills-chip';
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
interface BuilderSkillsSelectProps {
  skills: BuilderSkill[];
  setSkills: (skills: BuilderSkill[]) => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}
const skillsOptions: Option[] = [{
  value: BuilderSkill.BackendDevelopment,
  label: <BuildersSkillsChip skill={BuilderSkill.BackendDevelopment} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.DataEngineering,
  label: <BuildersSkillsChip skill={BuilderSkill.DataEngineering} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.DevopsEngineering,
  label: <BuildersSkillsChip skill={BuilderSkill.DevopsEngineering} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.FrontendDevelopment,
  label: <BuildersSkillsChip skill={BuilderSkill.FrontendDevelopment} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.FullStackDevelopment,
  label: <BuildersSkillsChip skill={BuilderSkill.FullStackDevelopment} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.QaTesting,
  label: <BuildersSkillsChip skill={BuilderSkill.QaTesting} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.SecurityEngineering,
  label: <BuildersSkillsChip skill={BuilderSkill.SecurityEngineering} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.SmartContractDevelopment,
  label: <BuildersSkillsChip skill={BuilderSkill.SmartContractDevelopment} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.TechnicalWriting,
  label: <BuildersSkillsChip skill={BuilderSkill.TechnicalWriting} />,
  group: 'Builder Skills'
}, {
  value: BuilderSkill.UiUxDesign,
  label: <BuildersSkillsChip skill={BuilderSkill.UiUxDesign} />,
  group: 'Builder Skills'
}];
function BuilderSkillsSelect(t0) {
  const $ = _c(13);
  const {
    skills,
    isLoading: t1,
    setSkills,
    className,
    disabled: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== skills) {
    t3 = skillsOptions.filter(option => skills.includes(option.value as BuilderSkill));
    $[0] = skills;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const selectedOptions = t3;
  let t4;
  if ($[2] !== setSkills) {
    t4 = options => {
      const values = options.map(_temp);
      setSkills(values);
    };
    $[2] = setSkills;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleChange = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("bg-background dark:bg-background");
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== className) {
    t6 = {
      className
    };
    $[5] = className;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== disabled || $[8] !== handleChange || $[9] !== isLoading || $[10] !== selectedOptions || $[11] !== t6) {
    t7 = <MultipleSelector value={selectedOptions} onChange={handleChange} options={skillsOptions} enableSearch={false} groupBy="group" enableSelectAll={true} selectAllGroup="Builder Skills" placeholder="Builder Skills" className={t5} commandProps={t6} customItemRenderer={_temp2} isLoading={isLoading} disabled={disabled} />;
    $[7] = disabled;
    $[8] = handleChange;
    $[9] = isLoading;
    $[10] = selectedOptions;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp2(option_1) {
  return option_1.label;
}
function _temp(option_0) {
  return option_0.value as BuilderSkill;
}
function BuilderSkillsSelectDrawer(t0) {
  const $ = _c(5);
  const {
    skills,
    setSkills
  } = t0;
  let t1;
  if ($[0] !== setSkills) {
    t1 = values => {
      setSkills(values as BuilderSkill[]);
    };
    $[0] = setSkills;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== handleChange || $[3] !== skills) {
    t2 = <DrawerSelect value={skills} onChange={handleChange} label="Builder Skills" options={skillsOptions} multiselect={true} enableSelectAll={true} selectAllLabel="Select All" />;
    $[2] = handleChange;
    $[3] = skills;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { BuilderSkillsSelect, BuilderSkillsSelectDrawer };